export const CHART = { lon0: 97, lon1: 176, lat0: -24.5, lat1: 19.5, width: 1000 } as const;

const rad = (d: number) => (d * Math.PI) / 180;
const merc = (lat: number) => Math.log(Math.tan(Math.PI / 4 + rad(lat) / 2));
const K = CHART.width / rad(CHART.lon1 - CHART.lon0);
const YT = merc(CHART.lat1);
export const CHART_HEIGHT = (YT - merc(CHART.lat0)) * K;

/** Chart units (Mercator, 1000 wide) for a longitude/latitude. */
export function proj(lon: number, lat: number): [number, number] {
  return [rad(lon - CHART.lon0) * K, (YT - merc(lat)) * K];
}

export function latAtY(y: number): number {
  return ((2 * Math.atan(Math.exp(YT - y / K)) - Math.PI / 2) * 180) / Math.PI;
}

/** Chart units covering one nautical mile east-west at a latitude. */
export function unitsPerNm(lat: number): number {
  return (rad(1 / 60) * K) / Math.cos(rad(lat));
}

const EARTH_NM = 3440.065;

/** Great-circle distance in nautical miles between [lon, lat] points. */
export function gcNm(a: [number, number], b: [number, number]): number {
  const [lon1, lat1] = a, [lon2, lat2] = b;
  const dLat = rad(lat2 - lat1), dLon = rad(lon2 - lon1);
  const h = Math.sin(dLat / 2) ** 2 + Math.cos(rad(lat1)) * Math.cos(rad(lat2)) * Math.sin(dLon / 2) ** 2;
  return 2 * EARTH_NM * Math.asin(Math.min(1, Math.sqrt(h)));
}
